/**
 * Emails allowed to preview reports before submission.
 * Internal-only — not exposed in UI.
 */
export const PREVIEW_ALLOWLIST = [
  "moe@cybersecureventures.com",
  "qa@csvpro.io",
  "michelle.a.isaac@gmail.com",
];
